export const IntegrationInboundMessageColumns = {
	model: [
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'ClassValuation', value: 'ClassValuation' },
				{ label: 'Cmp Acuity', value: 'cmpAcuity' },
			],
		},
		{
			label: 'Subject',
			key: 'subject'
		},
		{
			label: 'Body',
			key: 'body',
		},
		{
			label: 'Created By',
			key: 'createdBy'
		},
		{
			label: 'Handle Mode',
			key: 'handleMode',
			type: 'select',
		}
	],

	formBuilderConfig: {
		trackingSystem: {
			DataType: 'Selector',
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			type: 'select',
			UIControl: 'Dropdown',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'ClassValuation', value: 'ClassValuation' },
				{ label: 'Cmp Acuity', value: 'cmpAcuity' },
			],
		},
		subject: {
			DataType: 'String',
			DisplayText: 'Subject',
			Name: 'subject',
			isRequired: function(control, jsonModelService: any) {
				const bodyEmpty = jsonModelService.FindValue('body');
				return jsonModelService.IsEmpty() && !bodyEmpty;
			}
		},
		body: {
			DataType: 'String',
			DisplayText: 'Body',
			Name: 'body',
			isRequired: function(control, jsonModelService: any) {
				const subjectEmpty = jsonModelService.FindValue('subject');
				return jsonModelService.IsEmpty() && !subjectEmpty;
			}
		},
		createdBy: {
			DataType: 'String',
			DisplayText: 'Created By',
			Name: 'createdBy',
			hidden: true,
			required: false
		},
		handleMode: {
			DataType: 'Selector',
			DisplayText: 'Handle Mode',
			Name: 'handleMode',
			type: 'select',
			UIControl: 'Dropdown',
			options: [
				{ label: 'AsUnhandledMessage', value: 'AsUnhandledMessage' },
				{ label: 'AsHandledMessage', value: 'AsHandledMessage' },
				{ label: 'Ignore', value: 'Ignore' },
			],
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}
